import ChildAuthCode2 from "../../../components/childAuthCode/ChildAuthCode2"
import CoinStatementSection from "../coinTransactions/CoinStatementSection"
import useSelectedFamilyMember from "../hooks/useSelectedFamilyMember"

const ProgressTab = () => {
  const { selectedProfile } = useSelectedFamilyMember()

  if (!selectedProfile) return <></>

  return (
    <div className="flex flex-col gap-6 pt-4">
      <ChildAuthCode2 />
      <CoinStatementSection />
    </div>
  )
}

export default ProgressTab
